import "./App.scss";
import "./components/studio/styles.scss";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./context/ProtectedRoute";
import AdminLayout from "./context/AdminLayout";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import ClientsPage from "./components/ClientsPage";
import ProductsPage from "./components/ProductsPage";
import InvestmentsPage from "./components/InvestmentsPage";
import RecoveriesPage from "./components/RecoveriesPage";
import TreasuryPage from "./components/TreasuryPage";
import FundsPage from "./components/FundsPage";
import ReportsPage from "./components/ReportsPage";
import AuditPage from "./components/AuditPage";
import MobileWorkspace from "./components/MobileWorkspace";
import UsersPage from "./components/UsersPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/clients" element={<ClientsPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/investments" element={<InvestmentsPage />} />
                <Route path="/recoveries" element={<RecoveriesPage />} />
                <Route path="/treasury" element={<TreasuryPage />} />
                <Route path="/funds" element={<FundsPage />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/audit" element={<AuditPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/mobile" element={<MobileWorkspace />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
